/**
 * WHERE A FACT CAME FROM, SAID ONCE.
 *
 * Only ever rendered from `source === 'customer'`, which the backend asserts
 * from the intake form's own stamp. It is never inferred: claiming a customer
 * gave us something we cannot show they gave us is the one wrong answer here,
 * and a record nobody has touched since before the stamp existed is ours.
 *
 * Quiet on purpose. A badge beside every field would be a wall of badges; this
 * is one line under a section, or one line under a person.
 */
import page from '../../../shared/Page.module.css';

export function ProvenanceNote({ who, when }: { who?: string | null; when?: string | null }) {
  const day = when ? new Date(when).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  }) : null;
  return (
    <div className={page.itemMeta}>
      Provided by customer
      {who ? ` · ${who}` : ''}
      {day ? ` · ${day}` : ''}
    </div>
  );
}
